import Service from "../../../Services/index";

const Standard = {
    namespaced: true,
    state: {
        rows: [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        SET_ROWS: (state, res) => {
            state.table = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        }
    },
    actions: {
        getStandardList({commit}, data) {
            return Service.standard.getStandard(data);
        },
        showStandard({commit}, id) {
            return Service.standard.showStandard(id);
        },
        saveStandard({commit}, data) {
            return Service.standard.saveStandard(data);
        },
        deleteStandard({commit}, id) {
            return Service.standard.deleteStandard(id);
        },
        getWeightList({commit}, data) {
            return Service.standard.getWeight(data);
        },
        showWeight({commit}, id) {
            return Service.standard.showWeight(id);
        },
        saveWeight({commit}, data) {
            return Service.standard.saveWeight(data);
        },
        deleteWeight({commit}, id) {
            return Service.standard.deleteWeight(id);
        },
        deleteWeightDaily({commit}, data) {
            return Service.standard.deleteWeightDaily(data);
        },
        getCostList({commit}, data) {
            return Service.standard.getCostList(data);
        },
        getPlasticList({commit}, data) {
            return Service.standard.getPlasticList(data);
        },
        showCost({commit}, id) {
            return Service.standard.showCost(id);
        },
        saveCost({commit}, data) {
            return Service.standard.saveCost(data);
        },
        savePlastic({commit}, data) {
            data.plastic_type = data.plastic_type ? data.plastic_type.id : '';
            return Service.standard.savePlastic(data);
        },
        deleteCost({commit}, id) {
            return Service.standard.deleteCost(id);
        }
    }
};

export default Standard;
